import React from 'react';

/**
 * Create Context for Components using WP Menus
 * 'primary_menu', 'secondary_menu', 'mobile_menu'
 *
 */
const MenuContext = React.createContext();
export default MenuContext;
